import { __awaiter } from 'tslib';

const ENDPOINT = 'POSTfailupload';
function postFailUpload(gateway, params, customURL = null, customHeaders = null, isKoussa = false) {
    return __awaiter(this, void 0, void 0, function* () {
        return gateway.post(postFailUpload.endpoint, params, params, customURL, customHeaders, null, isKoussa);
    });
}
postFailUpload.endpoint = ENDPOINT;

export { postFailUpload as default };
//# sourceMappingURL=postFailUpload.js.map
